import React from 'react';

import type { FlagProps } from '../src/types';

const FlagPh = ({ className, testID }: FlagProps) => (
  <svg
    width={20}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testID}
    className={className}
    aria-hidden="true"
  >
    <mask
      id="prefix__a"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={15}
    >
      <path fill="#fff" d="M0 0h20v15H0z" />
    </mask>
    <g mask="url(#prefix__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0v15h20V0H0z"
        fill="#BF2714"
      />
      <mask
        id="prefix__b"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={15}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#prefix__b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0-1.25V7.5h20v-8.75H0z"
          fill="#3D58DB"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0v15l11.25-7.5L0 0z"
        fill="#F7FCFF"
      />
      <mask
        id="prefix__c"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={12}
        height={15}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0v15l11.25-7.5L0 0z"
          fill="#fff"
        />
      </mask>
      <g
        mask="url(#prefix__c)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FECA00"
      >
        <path d="m8.503 6.825.798.308.474-.559.013.747.733.239-.772.262.05.686-.508-.526-.8.153.473-.606-.46-.704zm-7.5 3.75.733.324.539-.575-.052.764.799.222-.837.278.115.67-.583-.478-.726.105.408-.59-.396-.72zm0-7.5.811.299.461-.55.026.738.72.248-.758.253.037.695-.505-.504-.804.13.486-.613-.474-.696zm4.073 6.008a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125z" />
        <path d="m4.891 5.15.084 1.004a.14.14 0 0 0 .277.004l.11-1a.238.238 0 1 0-.471-.008zm-.261.485.13.437c.012.04.052.065.098.057a.07.07 0 0 0 .052-.084l-.104-.438a.099.099 0 0 0-.122-.073.08.08 0 0 0-.054.1zm.702.455c-.01.037.011.075.053.087a.083.083 0 0 0 .096-.056l.145-.431a.08.08 0 0 0-.061-.105.1.1 0 0 0-.115.07l-.118.435zm1.298-.44-.699.772a.14.14 0 0 0 .192.2l.834-.632a.238.238 0 1 0-.327-.34zm-.213 1.638 1.043-.08a.238.238 0 1 1-.008.471l-1.04-.114a.14.14 0 0 1 .005-.277zM6.96 8.95l-.81-.706a.14.14 0 0 0-.2.193l.67.84a.238.238 0 1 0 .34-.327zm-1.676-.22.061 1.054a.238.238 0 1 1-.47-.009l.132-1.05a.14.14 0 0 1 .277.006zm-1.645.57.688-.838a.14.14 0 0 0-.192-.2l-.823.698a.239.239 0 1 0 .327.34zm.202-1.704-1.05.086a.238.238 0 1 1 .01-.471l1.045.108a.14.14 0 0 1-.005.277zM3.22 5.95l.89.689a.14.14 0 0 0 .2-.193l-.75-.823a.238.238 0 1 0-.34.327zm2.618.26.217-.4a.08.08 0 0 1 .118-.027c.042.03.054.088.026.132l-.236.383a.07.07 0 0 1-.096.023.084.084 0 0 1-.03-.11zm1.099.732-.437.13a.084.084 0 0 0-.057.098.07.07 0 0 0 .084.052l.438-.104a.099.099 0 0 0 .072-.121.08.08 0 0 0-.1-.055zM6.359 8.15l.4.217a.08.08 0 0 1 .028.118.099.099 0 0 1-.132.027l-.383-.237a.07.07 0 0 1-.023-.096.084.084 0 0 1 .11-.029zm-.731 1.1-.13-.437a.084.084 0 0 0-.098-.058.07.07 0 0 0-.052.084l.103.438a.099.099 0 0 0 .122.073.08.08 0 0 0 .055-.1zM4.42 8.671l-.217.4a.08.08 0 0 1-.118.028.099.099 0 0 1-.027-.132l.237-.383a.07.07 0 0 1 .096-.023.084.084 0 0 1 .029.11zm-1.1-.731.437-.13a.084.084 0 0 0 .058-.098.07.07 0 0 0-.084-.052l-.438.104a.099.099 0 0 0-.073.122.08.08 0 0 0 .1.054zm.58-1.206-.4-.217a.08.08 0 0 1-.028-.118.099.099 0 0 1 .132-.027l.383.237a.07.07 0 0 1 .023.096.084.084 0 0 1-.11.029zm2.33-.105c-.034.02-.046.062-.024.1a.084.084 0 0 0 .107.028l.407-.203a.08.08 0 0 0 .032-.117.099.099 0 0 0-.131-.03l-.391.222zm.165 1.069c.012-.041.05-.063.087-.053l.435.119a.099.099 0 0 1 .068.124.08.08 0 0 1-.103.051l-.432-.145a.083.083 0 0 1-.055-.096zm-.452.844c-.02-.034-.062-.045-.1-.024a.083.083 0 0 0-.028.107l.203.408a.08.08 0 0 0 .117.03.099.099 0 0 0 .03-.13l-.222-.391zm-1.069.166a.07.07 0 0 1 .053.086l-.119.435a.099.099 0 0 1-.124.068.08.08 0 0 1-.051-.102l.145-.432a.083.083 0 0 1 .096-.055zm-.844-.453c.034-.02.045-.062.024-.099a.083.083 0 0 0-.107-.029l-.408.203a.08.08 0 0 0-.03.117.099.099 0 0 0 .13.031l.391-.223zm-.166-1.069a.07.07 0 0 1-.086.053l-.435-.119a.099.099 0 0 1-.068-.124.08.08 0 0 1 .102-.05l.432.144c.04.014.064.055.055.096zm.453-.844a.07.07 0 0 0 .099.024.083.083 0 0 0 .029-.107l-.203-.408a.08.08 0 0 0-.117-.03.099.099 0 0 0-.031.13l.223.391z" />
      </g>
    </g>
  </svg>
);

export default FlagPh;
